// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.control-bar[data-v-cfaa6e8e] {
  width: 100%;
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
}
@media (prefers-reduced-motion: reduce) {
.control-bar[data-v-cfaa6e8e] {
    transition: none;
}
}
.control-bar.is-visible[data-v-cfaa6e8e] {
  opacity: 1;
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/apps/video-engine/components/video-call/controls/CallControlBar.vue","webpack://./CallControlBar.vue"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,mDAAA;ACDF;ADIA;AACE;IACE,gBAAA;ACDF;AACF;ADIA;EACE,UAAA;EACA,mBAAA;ACFF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.control-bar {\n  width: 100%;\n  z-index: 100;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s ease, visibility 0.2s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .control-bar {\n    transition: none;\n  }\n}\n\n.control-bar.is-visible {\n  opacity: 1;\n  visibility: visible;\n}\n",".control-bar {\n  width: 100%;\n  z-index: 100;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s ease, visibility 0.2s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .control-bar {\n    transition: none;\n  }\n}\n.control-bar.is-visible {\n  opacity: 1;\n  visibility: visible;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
